import { render, staticRenderFns } from "./IsThirdPartyInvolvedQuestion.vue?vue&type=template&id=0787209c&scoped=true"
import script from "./IsThirdPartyInvolvedQuestion.vue?vue&type=script&lang=ts"
export * from "./IsThirdPartyInvolvedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787209c",
  null
  
)

export default component.exports